import store from '@/store'
import { useLazyQuery } from '@vue/apollo-composable';
import * as api from '@/api/okaso-api'


export type SearchDiametersCondition = {
  customerId?: number;
  itemCd?: number;
  largeCategoryCd?: number;
  middleCategoryCd?: number;
  lengths?: string[];
  smallCategories?: api.SmallCategory[];
}

export function useSearchDiametersFunc() {

  const getWhere = (condition: SearchDiametersCondition) => {
    // 得意先で絞る --------------------
    let customerId = condition.customerId
    if (!customerId) {
      // ログイン中の得意先CDで絞り込む
      customerId = store.getters['loginUser/customer']?.id
    }

    const where: api.StockItemWhereInput  = {
      AND: [
        {
          stockItemUnitPrices: {
            some: {
              customerId: {
                equals: customerId
              }
            }
          }
        },
        {
          diameter: {
            not: {
              equals: ""
            }
          }
        }
      ],
    }

    // 商品で絞る --------------------
    // let itemId = condition.itemId
    // if (!!itemId) {
    //   where.AND?.push({
    //     item: {
    //       is: {
    //         id: { equals: itemId }
    //       }
    //     }
    //   })
    // }
    let itemCd = condition.itemCd
    if (!!itemCd) {
      where.AND?.push({
        item: {
          is: {
            itemCd: { equals: itemCd }
          }
        }
      })
    }

    // 大分類で絞る --------------------
    // let largeCategoryId = condition.largeCategoryId
    // if (!!largeCategoryId) {
    //   where.AND?.push({
    //     item: {
    //       is: {
    //         largeCategory: {
    //           is: {
    //             id: { equals: largeCategoryId }
    //           }
    //         }
    //       }
    //     }
    //   })
    // }
    let largeCategoryCd = condition.largeCategoryCd
    if (!!largeCategoryCd) {
      where.AND?.push({
        item: {
          is: {
            largeCategory: {
              is: {
                largeCd: { equals: largeCategoryCd }
              }
            }
          }
        }
      })
    }

    // 中分類で絞る --------------------
    // let middleCategoryId = condition.middleCategoryId
    // if (!!middleCategoryId) {
    //   where.AND?.push({
    //     item: {
    //       is: {
    //         middleCategory: {
    //           is: {
    //             id: { equals: middleCategoryId }
    //           }
    //         }
    //       }
    //     }
    //   })
    // }
    let middleCategoryCd = condition.middleCategoryCd
    if (!!middleCategoryCd) {
      where.AND?.push({
        item: {
          is: {
            middleCategory: {
              is: {
                middleCd: { equals: middleCategoryCd }
              }
            }
          }
        }
      })
    }

    // 長さで絞る --------------------
    let lengths = condition.lengths
    if (!!lengths && lengths.length > 0) {
      where.AND?.push({
        length: {
          in: lengths
        }
      })
    }


    return where
  }

  const {
    load: searchDiametersLoad,
    refetch: searchDiametersRefetch,
    onResult: searchDiametersOnResult,
    onError: searchDiametersOnError
  } = useLazyQuery<
    api.DiametersQuery,
    api.DiametersQueryVariables
  >(api.DiametersDocument, undefined)

  const searchDiametersFetchOrRefetch = (variables:api.DiametersQueryVariables) => {
    searchDiametersLoad(api.DiametersDocument, variables) || searchDiametersRefetch(variables)
  }

  const searchDiameters = ( condition: SearchDiametersCondition ) => {
    const where = getWhere(condition)

    // 検索実行
    searchDiametersFetchOrRefetch({
      where,
      orderBy: [
        {
          diameterCd: api.SortOrder.Asc,
        },
        {
          diameter: api.SortOrder.Asc,
        }
      ]
    })
  }

  return {
    searchDiameters,
    searchDiametersOnResult,
    searchDiametersOnError
  }
}
